export type PlateConfig = {
  weight: number
  count: number
  color: string
}

export const BAR_WEIGHT = 45

export const DEFAULT_PLATES: PlateConfig[] = [
  { weight: 55, count: 2, color: "#666666" },
  { weight: 45, count: 2, color: "#1a73e8" },
  { weight: 35, count: 2, color: "#fbbc04" },
  { weight: 25, count: 2, color: "#34a853" },
  { weight: 15, count: 2, color: "#ffffff" },
  { weight: 10, count: 2, color: "#ea4335" },
  { weight: 5, count: 2, color: "#333333" },
  { weight: 2.5, count: 2, color: "#9e9e9e" },
]

const STORAGE_KEY = "openiron-plate-config"

export function getPlateConfig(): PlateConfig[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return DEFAULT_PLATES
    }
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed) || parsed.length === 0) {
      return DEFAULT_PLATES
    }
    return parsed
  } catch {
    return DEFAULT_PLATES
  }
}

export function savePlateConfig(plates: PlateConfig[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(plates))
}

export function resetPlateConfig() {
  localStorage.removeItem(STORAGE_KEY)
}

export type PlateResult = {
  plates: PlateConfig[]
  totalWeight: number
  remainder: number
}

export function calculatePlates(
  targetWeight: number,
  barWeight: number = BAR_WEIGHT,
  plates: PlateConfig[] = DEFAULT_PLATES
): PlateResult {
  const perSide = (targetWeight - barWeight) / 2
  if (perSide <= 0) {
    return { plates: [], totalWeight: 0, remainder: 0 }
  }

  const sorted = [...plates].filter((p) => p.count >= 2).sort((a, b) => b.weight - a.weight)

  const result: PlateConfig[] = []
  let remaining = perSide

  for (const plate of sorted) {
    const pairsAvailable = Math.floor(plate.count / 2)
    let used = 0
    while (remaining >= plate.weight && used < pairsAvailable) {
      result.push(plate)
      remaining -= plate.weight
      used++
    }
  }

  const totalPerSide = perSide - remaining
  return {
    plates: result,
    totalWeight: barWeight + totalPerSide * 2,
    remainder: remaining * 2,
  }
}
